import { render, staticRenderFns } from "./MailboxActionsMenu.vue?vue&type=template&id=207402cb&"
import script from "./MailboxActionsMenu.vue?vue&type=script&lang=js&"
export * from "./MailboxActionsMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('207402cb')) {
      api.createRecord('207402cb', component.options)
    } else {
      api.reload('207402cb', component.options)
    }
    module.hot.accept("./MailboxActionsMenu.vue?vue&type=template&id=207402cb&", function () {
      api.rerender('207402cb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Email/MailboxActionsMenu.vue"
export default component.exports